// Bridges error-fix requests from the bundled App's ErrorBoundary
// (running cross-origin in the preview iframe) into a LiveView event.
//
// The ErrorBoundary in code_builder/builder.js posts:
//   window.parent.postMessage(
//     { type: 'seiva:fix-error', message, stack },
//     '*'
//   )
//
// We listen on the parent window, validate the shape, and push it to the
// LiveView so it can open the chat and dispatch a "corrige o erro" message
// for the agent to handle (which then runs app_recent_errors).
export default {
  mounted() {
    this.handleEvent('committee-build-fix', (payload) => {
      if (window.parent !== window) {
        window.parent.postMessage({type: 'seiva:committee:build-fix', ...payload}, window.location.origin)
      }
    })
    this._listener = (event) => {
      const data = event.data
      if (!data || typeof data !== 'object') return
      if (data.type !== 'seiva:fix-error') return
      const frame = Array.from(this.el.parentElement.querySelectorAll('iframe')).find(
        frame => frame.contentWindow === event.source
      )
      if (!frame || event.origin !== new URL(frame.src, window.location.href).origin) return

      this.pushEvent('fix_error_from_iframe', {
        message: String(data.message || '').slice(0, 800),
        stack: String(data.stack || '').slice(0, 4000),
      })
    }
    window.addEventListener('message', this._listener)
  },

  destroyed() {
    if (this._listener) {
      window.removeEventListener('message', this._listener)
      this._listener = null
    }
  },
}
